import { render, staticRenderFns } from "./FUniswapAddLiquidityConfirmation.vue?vue&type=template&id=182b42e6&"
import script from "./FUniswapAddLiquidityConfirmation.vue?vue&type=script&lang=js&"
export * from "./FUniswapAddLiquidityConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports